import { render, staticRenderFns } from "./formGroup.vue?vue&type=template&id=3ff571f2&scoped=true"
import script from "./formGroup.vue?vue&type=script&lang=js"
export * from "./formGroup.vue?vue&type=script&lang=js"
import style0 from "./formGroup.vue?vue&type=style&index=0&id=3ff571f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff571f2",
  null
  
)

export default component.exports